import type { RumEvent } from '@datadog/browser-rum';

const STACK_FRAME = /\n\s+at /;

export function isFramelessSourceError(event: RumEvent) {
  return (
    event.type === 'error' && event.error.source === 'source' && !hasStackFrames(event.error.stack)
  );
}

function hasStackFrames(stack: string | undefined) {
  return stack !== undefined && STACK_FRAME.test(stack);
}
